import { ScheduleContext } from '../../context'
import { useContextSelector } from 'use-context-selector'
import EventsSmallCalendar from '@containers/EventsCalendar/EventsSmallCalendar'

export default function CalendarFilter() {
  const selectedDate = useContextSelector(
    ScheduleContext,
    (context) => context.selectedDate
  )
  const setSelectedDate = useContextSelector(
    ScheduleContext,
    (context) => context.setSelectedDate
  )

  return (
    <EventsSmallCalendar
      selectedDate={selectedDate}
      setSelectedDate={setSelectedDate}
    />
  )
}
